import {REST_METHODS} from '@/src/app/constants/api';
import unauthorizedFetch from '@/src/app/utils/unauthorizedFetch';

const requestGetSpecialties = async () => {
  //@ts-ignore
  return unauthorizedFetch({
    method: REST_METHODS.GET,
    path: '/api/v1/dynamic_dictionary/specialties',
  });
};

export default requestGetSpecialties;
